import api from "..";

import { getFidelityByDDD, getOnlyNumbers } from "@/utils";
import { DebtSaleRequestExtraData, SaleRawData } from "./types";
import { GenericObject } from "@/utils/types";

const formatPayload = (data: SaleRawData) => {
  const debtPayment = {
    agencia: data.payment.agency,
    banco: data.payment.bank,
    conta: data.payment.account,
  };

  const bankData: Partial<DebtSaleRequestExtraData> =
    data.paymentType?.value === "Débito Automatico" ? debtPayment : {};

  const fidelidadeTIMId = {
    fidelidade: getFidelityByDDD(
      data.product.fidelidades,
      String(getOnlyNumbers(data.tel).slice(0, 2))
    )?.tim_id,
  };

  const loyaltyData = data.loyalty ? fidelidadeTIMId : {};

  const configurationPackage = data.product.pacote_configuracoes_id_substituto
    ? {
        pacote_configuracoes_id_substituto:
          data.product.pacote_configuracoes_id_substituto,
      }
    : {};

  return {
    venda_id: data.saleID,
    cliente_cpf: getOnlyNumbers(data.cpf),
    tipo: data.tipo,
    msisdn: getOnlyNumbers(data.tel),
    forma_pagamento: data.paymentType!.value,
    plano: data.product.tim_id,
    vencimento: data.payment.debtDueDate,
    cep: getOnlyNumbers(data.address.zipCode),
    ...loyaltyData,
    ...bankData,
    ...configurationPackage,
  };
};

export const requestUpdatePaymentData = async (saleData: SaleRawData) => {
  const { data } = await api.put(
    "/core/vendas/trocar-pagamento",
    formatPayload(saleData)
  );

  return data;
};

export const requestUpdatePaymentDataWithoutFormat = async (
  saleData: GenericObject
) => {
  const { data } = await api.put("/core/vendas/trocar-pagamento", saleData);

  return data;
};
